<template>
  <v-snackbar top
              right
              v-model="show"
              :timeout="timeout"
              :color="colors.snackbar">

    <span v-html="message"></span>

    <v-btn :color="colors.button"
           flat
           @click="show = false">
      &times;
    </v-btn>

  </v-snackbar>
</template>

<script>

    import EventBus from '@packages/event-bus'

    export default {
        data() {
            return {
                show: false,
                timeout: 10000,
                message: '',
                type: 'ERROR',
            }
        },

        computed: {
            colors() {
                if (this.type === 'ERROR')
                    return {
                        snackbar: '#FF4141',
                        button: '#FFFFFF'
                    }

                if (this.type === 'SUCCESS')
                    return {
                        snackbar: '#3CC480',
                        button: '#FFFFFF'
                    }

                return null
            }
        },

        methods: {
            showMessageHandler({type, message, timeout}) {
                this.type = type
                this.message = message
                this.timeout = timeout || 10000
                this.show = true
            }
        },

        mounted() {
            EventBus.$on('show-message', this.showMessageHandler)
        },
        beforeDestroy() {
            EventBus.$off('show-message', this.showMessageHandler);
        }
    }
</script>

<style scoped>
</style>
